<template>
  <component :is="componentType" />
</template>

<script lang="ts">
import { Component } from 'vue';
import { defineComponent, PropType } from 'vue-demi';

import AppDialerPopup from '../components/popups/AppDialerPopup.vue';
import AppDialerPage from '../components/pages/AppDialerPage.vue';
import {
  useCommonProps,
  useDialerActions,
} from '../composables';

export default defineComponent({
  name: 'AppDialerEntryPointContainer',
  props: {
    component: {
      type: String as PropType<'popup' | 'page'>,
      default: 'popup',
    },
  },
  setup() {
    const { pathToStore = [] } = useCommonProps();
    const { initializeVoiceAPI } = useDialerActions();
    return { pathToStore, initializeVoiceAPI };
  },
  computed: {
    componentType(): Component {
      switch (this.component) {
        case 'page':
          return AppDialerPage;
        case 'popup':
        default:
          return AppDialerPopup;
      }
    },
  },
  async beforeMount() {
    /* Connect call features to an abstract Voice API */
    await this.initializeVoiceAPI();
  },
});
</script>
